import React, { useState, useRef, useCallback } from "react";
import * as Scrivito from "scrivito";
import { useQuery } from "urql";
import { Container } from "reactstrap";
import { ProjectDataQry } from "api/queries";
import { ObjValidator } from "components";
import { ProjectHeader } from "components/ProjectHeader/ProjectHeader";
import { useAppBaseContext } from "providers/AppBaseProvider";
import { useProjectDataStore } from "stores/projectStore";
import { useTranslate } from "hooks";
import { PROJECT_CONFIGURATOR_TAB_TYPES } from "variables";
import { ProjectItemProperties } from "../../_ConfiguratorObjs/ProjectItem/SubComponents/ProjectItemProperties";
import { ProjectItemUploads } from "../../_ConfiguratorObjs/ProjectItem/SubComponents/ProjectItemUploads";
import { ProjectSummary } from "../../_ConfiguratorObjs/ProjectItem/SubComponents/ProjectSummary";

import s from "./ProjectItemSame.module.scss";

const ProjectItemSame = Scrivito.connect(({ page }) => {
  const translate = useTranslate();
  const [activeTab, setActiveTab] = useState(
    PROJECT_CONFIGURATOR_TAB_TYPES.PRODUCT_LIST,
  );
  const projectId = useProjectDataStore((state) => state.projectId) ?? "";
  const { lang: language } = useAppBaseContext();
  const redirectToProjectConfigurator = page.get(
    "redirectToProjectConfigurator",
  );

  const onRedirectToConfiguratorClick = () => {
    Scrivito.navigateTo(() => redirectToProjectConfigurator, {
      params: { projectId },
    });
  };
  const productListRef = useRef({});

  const handleChangeActiveTab = useCallback((e) => {
    setActiveTab(e.target.id);
  }, []);

  const [{ data, fetching }, reexecuteQuery] = useQuery({
    query: ProjectDataQry,
    variables: {
      input: { id: projectId, languageCode: language },
    },
    pause: !projectId,
  });

  const { project = {} } = data ?? {};

  return (
    <>
      <div className="bg-gray-100">
        <Container className="py-5_5">
          <div className="d-flex justify-content-between w-100">
            <div className="d-flex justify-content-between align-items-center gap-4 mb-1">
              <ProjectHeader
                projectId={projectId}
                title={translate("PROJECT_DETAILS")}
                project={project}
                page={page}
                productListRef={productListRef}
              />
            </div>
          </div>
          <h4 className={s.textWrap}>{project.title}</h4>
        </Container>
      </div>
      <ProjectItemProperties
        project={project}
        reexecuteQuery={reexecuteQuery}
        fetching={fetching}
      />
      <ProjectSummary
        project={project}
        redirectToProjectConfigurator={redirectToProjectConfigurator}
        onRedirectToConfiguratorClick={onRedirectToConfiguratorClick}
        productListRef={productListRef}
        activeTab={activeTab}
        handleChangeActiveTab={handleChangeActiveTab}
      />
      <ProjectItemUploads />
    </>
  );
});

const CheckedPage = (props) => (
  <ObjValidator {...props}>
    <ProjectItemSame {...props} />
  </ObjValidator>
);
export default CheckedPage;
Scrivito.provideComponent("ProjectItemSame", CheckedPage);
